import React, { useState, useEffect } from "react";
import { supabase } from "../supabase";
import { fetchVenueData } from "../Utils/VenueUtils";

const Canvas = ({ children, showTime }) => {

    const [venue, setVenue] = useState(null);
    const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
        if (!showTime) return;

        // Update clock every second
        const interval = setInterval(() => {
            const now = new Date();
            const formattedTime = now.toLocaleTimeString("en-GB", { hour12: false }); // HH:MM:SS format
            setCurrentTime(formattedTime);
        }, 500);

        return () => clearInterval(interval); // Cleanup interval on unmount
    }, []);

    // Fetch venue data using the utility function
    useEffect(() => {
        const loadVenueData = async () => {
            try {
                const venueId = new URLSearchParams(window.location.search).get("venue_id");
                console.log("venueId:" + venueId);
                
                if (isNaN(venueId)) {
                    console.error("Invalid venue ID");
                    return;
                }
                
                const data = await fetchVenueData(venueId);
                if (data) {
                    setVenue(data);
                } else {
                    console.error("No venue found with the given ID");
                }
            } catch (err) {
                console.error("Unexpected error:", err);
            }
        };

        loadVenueData();
    }, []);

    return (
        <div className="live">
            <div
                className="header"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0px 8px",
                }}


            >

                <h1 style={{ margin: "0px" }}>
                    <span style={{ color: "#006fb7", fontSize: "0.85em" }}>SPORT.VLAANDEREN</span>&nbsp;
                    <span style={{ color: "#38b3e8", fontSize: "0.6em", textTransform: "uppercase" }}>{venue?.city}</span></h1>
                {showTime && <h1 style={{ margin: "0px", color: "#363635" }}>{currentTime}</h1>}


            </div>

            {children}
        </div>
    )
}

export default Canvas;